var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnectorPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2311_74179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2696 21.1612C15.2696 21.1612 9.90021 21.1612 7.45508 21.1612C5.00995 21.1612 4.9456 20.0018 4.9456 18.5717L4.94531 5.58264C4.94531 4.15242 5.01018 2.99316 7.45508 2.99316C9.89998 2.99316 15.2693 2.99316 15.2693 2.99316",
    stroke: "#DDDEE0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2696 12.077L5.94531 12.0771",
    stroke: "#DDDEE0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1241 2.99261C19.1241 4.05378 18.2637 4.91411 17.2026 4.91411C16.1414 4.91411 15.2812 4.05378 15.2812 2.99261C15.2812 1.93144 16.1414 1.07129 17.2026 1.07129C18.2637 1.07129 19.1241 1.93144 19.1241 2.99261Z",
    stroke: "#DDDEE0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1241 12.0768C19.1241 13.1379 18.2637 13.9983 17.2026 13.9983C16.1414 13.9983 15.2812 13.1379 15.2812 12.0768C15.2812 11.0156 16.1414 10.1553 17.2026 10.1553C18.2637 10.1553 19.1241 11.0156 19.1241 12.0768Z",
    stroke: "#DDDEE0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1163 21.1498C19.1163 22.211 18.2561 23.0713 17.1949 23.0713C16.1338 23.0713 15.2734 22.211 15.2734 21.1498C15.2734 20.0887 16.1338 19.2285 17.1949 19.2285C18.2561 19.2285 19.1163 20.0887 19.1163 21.1498Z",
    stroke: "#DDDEE0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2311_74179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.0390625 0.0712891)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectorPin);
export default __webpack_public_path__ + "static/media/connector_pin.e9f6c0eca9909e5595914a97c9a60d85.svg";
export { ForwardRef as ReactComponent };